import styled from 'styled-components';
import { zIndexLayers } from 'constants/zIndexLayers';

export const I18nLanguageSwitcher = styled.button`
  position: fixed;
  bottom: 10px;
  right: 10px;
  z-index: ${zIndexLayers.translationSwitch};
  cursor: pointer;
`;
